import React from 'react';
import { Container } from 'semantic-ui-react';
import { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux'
import Boxinfoservices from '../../../components/Micuentacardboxs/Boxinfoservices';
import Boxdireccion from '../../../components/Micuentacardboxs/Boxdireccion';
import Boxdispach from '../../../components/Micuentacardboxs/Boxdispach';


export const OpcionesLaterales = (props) => {
 //console.log(props)
  return (
    <Container>
    <Boxinfoservices serviciosAct={props.serviciosAct}></Boxinfoservices>

    <Boxdireccion></Boxdireccion>

    <Boxdispach></Boxdispach>

    </Container>
    
  );
};
